export class DateString {

    public static toISOString(date?:any) {
        if (!date)  date=new Date();
        else date=new Date(date)
        const today=new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().replace(/T/, ' ').replace(/\..+/, '');  
        return today;
    }

}